import { render, staticRenderFns } from "./EditOrg.vue?vue&type=template&id=d22402a0"
import script from "./EditOrg.vue?vue&type=script&lang=js"
export * from "./EditOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports